module.exports = __webpack_public_path__ + "media/newstyle/images/icon-mercadolivre-8e6b02fb7afabc44f729323c75305c50.svg";